<template>
    <div class="PNWILSProgramEditor">
        <!--DISPLAY TABLE-->
        <b-container>
            <b-row style="overflow-x:auto;">
                <b-col cols="11">
                    <vuetable :fields="TableFields"
                              :data="TableData"
                              pagination-path=""
                              :api-mode="false"
                              class="vue-datatable"
                              :row-class="onRowClass">

                        <template slot="DetailView" scope="props">
                            <div class="DetailView">
                                <span class="underline pointer" @click="ShowDetailView(props.rowData)"><span v-html="props.rowData.Name"></span> <font-awesome-icon :icon="['fa', 'edit']" v-if="EditMode" /></span>
                            </div>
                        </template>
                    </vuetable>
                </b-col>
                <b-col cols="1">
                    <div v-if="EditMode && CheckPermission(EditPermission)" class="vert-icons">
                        <b-row>
                            <font-awesome-icon :icon="['fa', 'plus']" v-on:click="ShowAddEditRecord()" class="pointer olive-green-text" />
                        </b-row>
                    </div>
                </b-col>
            </b-row>
        </b-container>

        <!--ADD AND EDIT AND DETAIL MODAL-->
        <b-modal ref="modal-Record" :title="ModalRecordTitle" hide-footer>
            <b-container v-if="EditMode == false && TargetRecord.Id">
                <b-row>
                    <b-col>
                        <h3>Program Info</h3>
                        <p><span class="bold">County: </span>{{TargetRecord.County}}</p>
                        <p><span class="bold">Name: </span>{{TargetRecord.Name}}</p>
                    </b-col>
                    <b-col>
                        <h3>Enrollment Details</h3>
                        <p><span class="bold">Start Date: </span>{{ formatDate(TargetRecord.StartDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">End Date: </span>{{ formatDate(TargetRecord.EndDate,'MM/DD/YY') }}</p>
                    </b-col>
                </b-row>
                <b-row class="modal-btn-row">
                    <div class="modal-btn-row-div">
                        <b-button size="md" variant="secondary" @click="CancelRecord()">
                            CLOSE
                        </b-button>
                    </div>
                </b-row>
            </b-container>
            <b-container v-if="EditMode">
                <b-form @submit="AddEditRecord" autocomplete="off">
                    <b-row>
                        <b-col>
                            <h3>Program Info</h3>
                            <div class="form-group">
                                <label>County:</label>
                                <select type="text" required class="form-control" v-model="TargetRecord.County">
                                    <option value="Clallum">Clallum</option>
                                    <option value="Clark">Clark</option>
                                    <option value="Cowlitz">Cowlitz</option>
                                    <option value="Grays Harbor">Grays Harbor</option>
                                    <option value="Jefferson">Jefferson</option>
                                    <option value="Kitsap">Kitsap</option>
                                    <option value="Lewis">Lewis</option>
                                    <option value="Mason">Mason</option>
                                    <option value="Pacific">Pacific</option>
                                    <option value="Pierce">Pierce</option>
                                    <option value="Skamania">Skamania</option>
                                    <option value="Thurston">Thurston</option>
                                    <option value="Wahkiakum">Wahkiakum</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Program Name:</label>
                                <select type="text" required class="form-control" v-model="TargetRecord.ProgramServiceID">
                                    <!--KITSAP-->
                                    <optgroup label="ILS ENROLLMENT" v-if="TargetRecord.County == 'Kitsap'">
                                        <option value="a0a580e7-3309-4de9-9ddd-83033e614605">ILS DCYF</option>
                                        <option value="30af91a6-9bd1-484a-a41b-42942c39d259">Olive Crest ILS</option>
                                        <option value="42d9702a-f2fa-45ec-bde0-7126f93dc7d3">ILS Therapeutic Courts</option>
                                    </optgroup>
                                    <optgroup label="HOUSING" v-if="TargetRecord.County == 'Kitsap'">
                                        <option value="71dced90-63f1-4505-bf81-4e0d913cd7ef">HHGP HP</option>
                                        <option value="6796631e-4023-4174-8d1c-e9e19040bf83">HHGP RR</option>
                                        <option value="f93fe424-376c-4420-adc0-827ce2c6ed6d">HHGP Case Management Only</option>
                                        <option value="48df1b4a-f2af-4c74-9805-b57bc111a640">THP</option>
                                        <option value="0da22e48-6be5-4146-9fc1-f7cb73b2b48e">FYI HP</option>
                                        <option value="a1d6b8d0-5e8f-4aab-9f1e-2c9d6390f9b4">FYI RR</option>
                                        <option value="59329549-d65a-4fde-a062-b5bd4362bd3a">IYHP HP</option>
                                        <option value="884f4fac-c139-40a7-99f0-2482b324d803">IYHP RR</option>
                                        <option value="bf105cd6-c4f5-4bc0-824a-50443129dde8"> FYI Hold - No Bill</option>
                                    </optgroup>
                                    <optgroup label="THERAPEUTIC COURT" v-if="TargetRecord.County == 'Kitsap'">
                                        <option value="905dad88-868b-4a1a-9156-6a600c9bf93a">Girls Court</option>
                                        <option value="2aea5f01-815b-4f22-b04f-a02b0cf93c76">KPAC</option>
                                        <option value="0c7cb489-3450-4207-85ca-c7ccf7f7669d">ITC</option>
                                        <option value="e85c6f5e-a13d-4660-8034-1da8be40fb5b">JDC</option>
                                        <option value="bcf9660b-3d16-4dee-a922-4dcfedf57b38">Probation</option>
                                    </optgroup>

                                    <!--GRAYS HARBOR-->
                                    <optgroup label="ILS ENROLLMENT" v-if="TargetRecord.County == 'Grays Harbor'">
                                        <option value="0bf4aa5d-6118-4e39-bd73-ac41bd5e0861">ILS DCYF</option>
                                        <option value="8d7e046d-ea37-422c-be1a-3b0b26de4b31">Olive Crest ILS</option>
                                    </optgroup>
                                    <optgroup label="HOUSING" v-if="TargetRecord.County == 'Grays Harbor'">
                                        <option value="bce4a78a-e8c6-4bf4-b0ac-4d58e34e171a">FYI HP</option>
                                        <option value="10a9683f-60b3-48ed-a2d7-906898fcf35b">FYI RR</option>
                                        <option value="6eade741-e78a-4bee-8e37-0ab5a8c597fc"> FYI Hold - No Bill</option>
                                    </optgroup>

                                    <!--PACIFIC-->
                                    <optgroup label="ILS ENROLLMENT" v-if="TargetRecord.County == 'Pacific'">
                                        <option value="cbae0d2c-9676-4a0d-98c0-564f6bed0827">ILS DCYF</option>
                                        <option value="d95f8e9e-56e3-4a1a-a980-7e2d882ce2dc">Olive Crest ILS</option>
                                    </optgroup>
                                    <optgroup label="HOUSING" v-if="TargetRecord.County == 'Pacific'">
                                        <option value="06b90383-f5ba-46c0-b1c0-cb0c385ad7ca">FYI HP</option>
                                        <option value="5be81c4a-7aee-43d6-872c-ee6bda4394a7">FYI RR</option>
                                        <option value="ce792e8f-e565-46a4-9bc6-62a22f4808aa"> FYI Hold - No Bill</option>
                                    </optgroup>

                                    <!-- Pierce -->
                                    <optgroup label="ILS ENROLLMENT" v-if="TargetRecord.County == 'Pierce'">
                                        <option value="46ac83e6-5a7f-454f-b8ac-31cee9403875">ILS DCYF</option>
                                        <option value="82ea178c-bab4-464e-8e97-3ea9e86d44ed">Olive Crest ILS</option>
                                    </optgroup>
                                    <optgroup label="HOUSING" v-if="TargetRecord.County == 'Pierce'">
                                        <option value="9ee2e8c3-f7a0-4490-9414-7327e31fbf5f">FYI HP</option>
                                        <option value="01e5faab-430f-4f5e-94f8-6af9e3ce3047">FYI RR</option>
                                        <option value="ba1c5d18-83b2-45a6-859a-c88405bef462"> FYI Hold - No Bill</option>
                                    </optgroup>
                                    <!-- Clallum -->
                                    <optgroup label="ILS ENROLLMENT" v-if="TargetRecord.County == 'Clallum'">
                                        <option value="6eb3e611-2829-488d-8a86-24a23b6d2de2">ILS DCYF</option>
                                        <option value="3c8cd1f6-c810-4436-abfa-78924f5086ad">Olive Crest ILS</option>
                                    </optgroup>
                                    <optgroup label="HOUSING" v-if="TargetRecord.County == 'Clallum'">
                                        <option value="5c7e0f9d-9dfe-4b93-81f5-beaa63f2663b">FYI HP</option>
                                        <option value="5f2a0cfc-f3bb-4fcc-9bd7-45c7fa33afac">FYI RR</option>
                                        <option value="c86c6d81-8b5f-46b4-83e3-dc164f85b428"> FYI Hold - No Bill</option>
                                    </optgroup>
                                    <!-- Jefferson -->
                                    <optgroup label="ILS ENROLLMENT" v-if="TargetRecord.County == 'Jefferson'">
                                        <option value="b9199479-3b96-4c7c-b82b-ca28ed3e5b1c">ILS DCYF</option>
                                        <option value="e919ef3b-1717-4626-ab1f-9a9a8389a17e">Olive Crest ILS</option>
                                    </optgroup>
                                    <optgroup label="HOUSING" v-if="TargetRecord.County == 'Jefferson'">
                                        <option value="4c3e4fb9-a6a5-471f-9e36-323d7b661955">FYI HP</option>
                                        <option value="7c5c4ff3-d4ed-4cc1-b418-9f881d859b58">FYI RR</option>
                                        <option value="1209bf07-5d2f-4ade-a21d-671dfba82678"> FYI Hold - No Bill</option>
                                    </optgroup>
                                    <!-- Mason -->
                                    <optgroup label="ILS ENROLLMENT" v-if="TargetRecord.County == 'Mason'">
                                        <option value="b93e56c1-6e55-4e6e-ad3c-cea53da52cc3">ILS DCYF</option>
                                        <option value="0fd0f661-cd61-426f-8205-97d146753f40">Olive Crest ILS</option>
                                    </optgroup>
                                    <optgroup label="HOUSING" v-if="TargetRecord.County == 'Mason'">
                                        <option value="44cc1926-ac71-49ea-82c4-b1e636b58702">FYI HP</option>
                                        <option value="45ad9130-bbb6-4dbf-ab24-ce8aafb9d28c">FYI RR</option>
                                        <option value="1fcd4b01-9e41-42b9-83af-5840fb80d3f5"> FYI Hold - No Bill</option>
                                    </optgroup>
                                    <!-- Thurston -->
                                    <optgroup label="ILS ENROLLMENT" v-if="TargetRecord.County == 'Thurston'">
                                        <option value="4d0217db-ea4f-4231-b40d-745c9ddfe105">ILS DCYF</option>
                                        <option value="e0dc654f-5d01-484f-93ad-25646e6eddd6">Olive Crest ILS</option>
                                    </optgroup>
                                    <optgroup label="HOUSING" v-if="TargetRecord.County == 'Thurston'">
                                        <option value="f1780447-981a-4e5c-a8e5-2740f22d4f5f">FYI HP</option>
                                        <option value="e9e98596-5927-47de-ba1c-4e775e437b33">FYI RR</option>
                                        <option value="363155ff-f5b2-4f91-98f0-14cf330d9ad4"> FYI Hold - No Bill</option>
                                    </optgroup>
                                    <!-- Lewis -->
                                    <optgroup label="ILS ENROLLMENT" v-if="TargetRecord.County == 'Lewis'">
                                        <option value="6c25e61f-24d6-418c-8bf0-3b441082d660">ILS DCYF</option>
                                        <option value="5372bfd6-0b73-4deb-ad08-c0c893501ef0">Olive Crest ILS</option>
                                    </optgroup>
                                    <optgroup label="HOUSING" v-if="TargetRecord.County == 'Lewis'">
                                        <option value="436ddc5e-7b56-4644-be36-88c7f263f445">FYI HP</option>
                                        <option value="be84b5f0-3435-490c-b775-3b2484a29964">FYI RR</option>
                                        <option value="466c5950-d004-44f4-84ae-22c590292507"> FYI Hold - No Bill</option>
                                    </optgroup>
                                    <!-- Wahkiakum -->
                                    <optgroup label="ILS ENROLLMENT" v-if="TargetRecord.County == 'Wahkiakum'">
                                        <option value="40c1d5e3-1a26-40e5-a61e-b81cb6be2d9c">ILS DCYF</option>
                                        <option value="0c32e993-e5cf-4301-9f2c-ec79a986df2e">Olive Crest ILS</option>
                                    </optgroup>
                                    <optgroup label="HOUSING" v-if="TargetRecord.County == 'Wahkiakum'">
                                        <option value="9fde889a-0bb0-4f4f-8b74-031eeb5942b3">FYI HP</option>
                                        <option value="93d74332-861e-44af-9085-eb7e40474bcc">FYI RR</option>
                                        <option value="92582708-9194-446a-bda4-911db9a2d67c"> FYI Hold - No Bill</option>
                                    </optgroup>
                                    <!-- Cowlitz -->
                                    <optgroup label="ILS ENROLLMENT" v-if="TargetRecord.County == 'Cowlitz'">
                                        <option value="baf97821-2b1d-480b-8a52-98853ccc31ee">ILS DCYF</option>
                                        <option value="4e63a8fa-14ea-4987-bd2e-9ed7971db680">Olive Crest ILS</option>
                                    </optgroup>
                                    <optgroup label="HOUSING" v-if="TargetRecord.County == 'Cowlitz'">
                                        <option value="790d878d-c002-4514-9290-f3ce279e1907">FYI HP</option>
                                        <option value="a027790c-9812-42a5-8c42-fb017b735a69">FYI RR</option>
                                        <option value="43c371d2-58ac-4156-af0c-4b8cf9c528f9"> FYI Hold - No Bill</option>
                                    </optgroup>
                                    <!-- Clark -->
                                    <optgroup label="ILS ENROLLMENT" v-if="TargetRecord.County == 'Clark'">
                                        <option value="e900939f-4f3c-41c9-ac84-8d4cc4cd14a1">ILS DCYF</option>
                                        <option value="b9fdbc0b-9bb1-443b-9b5e-379d145ff6cf">Olive Crest ILS</option>
                                    </optgroup>
                                    <optgroup label="HOUSING" v-if="TargetRecord.County == 'Clark'">
                                        <option value="8610a0b2-74b6-4f4b-a888-d08ba6bc76bf">FYI HP</option>
                                        <option value="8f01a3ed-4ea5-47cf-ba42-63fa99dc1a41">FYI RR</option>
                                        <option value="b88a53d0-e4ff-4678-9626-8347a057e4b1"> FYI Hold - No Bill</option>
                                    </optgroup>
                                    <!-- Skamania -->
                                    <optgroup label="ILS ENROLLMENT" v-if="TargetRecord.County == 'Skamania'">
                                        <option value="af8b31d5-baee-4f79-a7c6-e15317e0e675">ILS DCYF</option>
                                        <option value="c83f5c8d-f48a-45c3-b34e-d5f91f859b3b">Olive Crest ILS</option>
                                    </optgroup>
                                    <optgroup label="HOUSING" v-if="TargetRecord.County == 'Skamania'">
                                        <option value="f3c1b136-439a-449f-96a3-4a717775e91d">FYI HP</option>
                                        <option value="0ac066f8-8796-4f01-a699-83cc569acb24">FYI RR</option>
                                        <option value="16b363ea-52d7-40ce-9ef8-e55ef76147e8"> FYI Hold - No Bill</option>
                                    </optgroup>
                                </select>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <h3>Enrollment Details</h3>
                            <div class="form-group">
                                <label>Start Date:</label>
                                <flat-pickr v-model="TargetRecord.StartDate" class="form-control" required :config="DateConfig"></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>End Date:</label>
                                <flat-pickr v-model="TargetRecord.EndDate" class="form-control" :config="DateConfig"></flat-pickr>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelRecord()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit" v-if="EditMode">
                                SAVE
                            </b-button>
                            <b-button size="md" variant="danger" @click="DeleteRecord()" type="button" v-if="TargetRecord.Id">
                                DELETE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>

</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import Vuetable from 'vuetable-2/src/components/Vuetable';
    import { EventBus } from '../../../services/event-bus.js';

    export default {
        props: [
            "EditMode",//bool
            "ChildRecordData",
            "EditPermission"
        ],
        data: function () {
            return {
                TargetRecord: {},
                ModalRecordTitle: "",
                LoadedRecords: [],
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                    required: false
                }

            };
        },
        methods: {
            onRowClass(dataItem, index) {
                return (dataItem.EndDate == null) ? 'current-record' : '';
            },
            GetRecords() {
                this.$MasterAPI.ExecuteRequest("GET", 'Tay/MultiServices', {ClientSubProgramMembershipID: this.ChildRecordData.Id} , this.GetRecordsSuccess, () => { }, false)
            },
            GetRecordsSuccess(response) {
                this.LoadedRecords = response.data.data;
            },
            ShowDetailView(Record) {
                this.TargetRecord = JSON.parse(JSON.stringify(Record));

                if (this.EditMode) {
                    this.ModalRecordTitle = "Editing " + Record.Name;
                } else {
                    this.ModalRecordTitle = "Viewing " + Record.Name;
                }
                this.$refs["modal-Record"].show();
            },
            ShowAddEditRecord() {
                this.TargetRecord = {};
                this.ModalRecordTitle = "Add New Record";
                this.$refs["modal-Record"].show();
            },
            AddEditRecord(e) {
                e.preventDefault();
                this.TargetRecord.ClientSubProgramMembershipID = this.ChildRecordData.Id;
                //get person data here
                this.$MasterAPI.ExecuteRequest("POST", 'Tay/MultiServices', this.TargetRecord, this.AddEditRecordSuccess, () => { }, true);
            },
            AddEditRecordSuccess(response) {
                this.GetRecords();
                this.$refs["modal-Record"].hide();
            },
            DeleteRecord() {
                this.$MasterAPI.ExecuteRequest("DELETE", 'Tay/MultiServices/' + this.TargetRecord.Id, {}, this.DeleteRecordSuccess, () => { }, true);
            },
            DeleteRecordSuccess(response) {
                this.GetRecords();
                this.$refs["modal-Record"].hide();
            },
            CancelRecord() {
                this.$refs['modal-Record'].hide();
            },
            formatDate(value, fmt = 'D MMM YYYY') {
                return (value == null || value == '')
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
        },
        components: {
            flatPickr,
            Vuetable
        },
        computed: {
            TableFields: function () {
                let vm = this;
                let fieldData = [
                    {
                        name: "__slot:DetailView",
                        title: "PROGRAM"
                    },
                    {
                        name: "StartDate",
                        title: "STARTED",
                        callback: 'formatDate|MM/DD/YY',
                    },
                    {
                        name: "EndDate",
                        title: "ENDED",
                        callback: 'formatDate|MM/DD/YY',
                    }
                ];
                return fieldData;
            },
            TableData: function () {
                return this.LoadedRecords;
            }
        },
        mounted() {
            this.GetRecords();
        }
    }
</script>

<style scoped>
    .vert-icons div {
        margin-top: 10px;
    }

    /deep/ tbody tr.current-record {
        font-weight: bold;
    }

    table {
        table-layout: auto;
    }

    .vue-datatable {
        width: 100%;
        display: inline-table;
        overflow-x: auto;
    }
</style>